import { render, staticRenderFns } from "./ReportResultTableHutang.vue?vue&type=template&id=b0b467a8"
import script from "./ReportResultTableHutang.vue?vue&type=script&lang=js"
export * from "./ReportResultTableHutang.vue?vue&type=script&lang=js"
import style0 from "./ReportResultTableHutang.vue?vue&type=style&index=0&id=b0b467a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports